module.exports = __webpack_public_path__ + "media/images/shared/ebt-head-ea38254e21c46b0cb4e266fa381a5514efc1f6aae86b7c3f7c91f50a98c061cf.png";